import { useMemo } from 'react';

import { useBlockContext } from '../../../Block/context';
import { BLOCKS_CONFIG } from '../../configs';

export function useChildrenBlocks() {
  const { block: parentBlock, readonly } = useBlockContext();

  const childrenBlocks = useMemo(() => {
    return parentBlock.children?.map((chb) => {
      if (chb._destroy) return null;

      const config = BLOCKS_CONFIG[chb.type];

      if (!config) return null;

      const { Component } = config;

      if (!Component) {
        return null;
      }

      return chb;
    });
  }, [parentBlock.children]);

  const hasNothingToRender = useMemo(() => {
    if (!childrenBlocks) return true;

    return childrenBlocks.filter((chb) => chb !== null).length === 0;
  }, [childrenBlocks]);

  const showAloneAddNewContent = !readonly && hasNothingToRender;

  return {
    childrenBlocks,
    showAloneAddNewContent,
  };
}
